import Http from 'axios'
import {API_URL, VERSION} from '../../config/config'
import {SET_TIPPANI} from "../mutation-type";
import {GET_TIPPANI, GET_TIPPANI_WITH_TYPE} from "../action-type";

function initialState() {
    return {
        tippanis: [],
        selectedTippani: null,
        generatedTippani: null
    }
}

const getters = {
    tippanis: state => state.tippanis,
    selectedTippani: state => state.selectedTippani,
    generatedTippani: state => state.generatedTippani
};

const actions = {
    [GET_TIPPANI]({commit}, visa_type) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/tippani?visa_type=${visa_type}`).then((res) => {
                commit(SET_TIPPANI, res.data.data);
                resolve(true)
            })
        }));
    },
    [GET_TIPPANI_WITH_TYPE]({commit}, tippani_type) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/tippani/trekking?tippani_type=${tippani_type}`).then((res) => {
                commit(SET_TIPPANI, res.data.data);
                resolve(true)
            })
        }));
    },
};

const mutations = {
    SET_TIPPANI(state, items) {
        state.tippanis = items
    },
    SET_SELECTED_TIPPANI(state, tippani) {
        state.selectedTippani = tippani;
    },
    SET_GENERATED_TIPPANI(state, generated_tippani) {
        console.log(generated_tippani)
        state.generatedTippani = generated_tippani;
    }

}

export default {
    state: initialState,
    getters,
    actions,
    mutations
}
